"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlotSchema = void 0;
const zod_1 = require("zod");
const ESlotType_1 = require("./ESlotType");
const SlotSchema = zod_1.z.object({
    slotNumber: zod_1.z.number(),
    slotAbsoluteNumber: zod_1.z.number(),
    slotType: zod_1.z.nativeEnum(ESlotType_1.ESlotType),
    // should slotHaveEffect: z.boolean(), ????
});
exports.SlotSchema = SlotSchema;
